import { useQuery } from '@tanstack/react-query';
import { getCampaignSetup } from '../Cadastro/services';

type CampaignSetup = {
  editOffer: boolean;
  priority?: 'PRIORITY_TYPE' | 'PRICE_LOWER';
};

export const useGetCampaignSetup = () => {
  return useQuery<CampaignSetup>({
    queryKey: ['campaign-setup'],
    queryFn: getCampaignSetup,
  });
};
